import React from 'react';
import { Alert, Box, Button, Container, Typography } from '@mui/material';

interface LogEntry {
  timestamp: string;
  level: 'info' | 'success' | 'error' | 'warning';
  message: string;
}

interface ExecutionLogProps {
  entries: LogEntry[];
  onClear: () => void;
}

const ExecutionLog: React.FC<ExecutionLogProps> = ({ entries, onClear }) => {
  return (
    <Container maxWidth="md">
      <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Typography variant="h5">Execution Log</Typography>
        <Button variant="outlined" size="small" onClick={onClear}>
          Clear Log
        </Button>
      </Box>

      {entries.length === 0 ? (
        <Typography color="text.secondary" sx={{ fontStyle: 'italic' }}>
          No log entries yet. Run a pipeline to see activity here.
        </Typography>
      ) : (
        <Box sx={{ maxHeight: 600, overflowY: 'auto' }}>
          {[...entries].reverse().map((entry, index) => (
            <Alert key={index} severity={entry.level} sx={{ mb: 1 }}>
              [{entry.timestamp}] {entry.message}
            </Alert>
          ))}
        </Box>
      )}
    </Container>
  );
};

export default ExecutionLog;
